const ProductCalculator = {
  board: {
    width: 0,
    height: 0,
    length: 0,
    gap: 0,
    area: 0,
  },

  widthEl: "",
  heightEl: "",
  lengthEl: "",
  gapEl: "",

  calcEl: "",
  selectLengthEl: "",

  init() {
    this.bindings();
    this.events();
  },

  /**
   * Set calulator elements
   */
  bindings() {
    this.calcEl = $("#prod-calculator");
    this.selectLengthEl = $("#pa_garums");

    this.lengthEl = $("#calc-length");
    this.widthEl = $("#calc-width");
    this.heightEl = $("#calc-height");
    this.gapEl = $("#calc-gap");

    this.lengthEl.text(this.selectLengthEl.val());

    if ($(".variations_form").length) {
      this.calcEl.find("[name=length]").val(this.selectLengthEl.val());
    }
  },

  events() {
    // On load init calc
    setTimeout(() => {
      ProductCalculator.createCalc();
    }, 100);

    // On length change
    this.selectLengthEl.on("change", (e) => {
      const value = e.target.value;

      setTimeout(() => {
        ProductCalculator.createCalc(value);
      }, 100);
    });

    // On board change.
    this.calcEl.find("[name=plank-count]").on("input", (e) => {
      const board = ProductCalculator.board;

      const plankCount = parseFloat(e.target.value);

      // running meters
      const runningMeters = (plankCount * board.length) / 1000;
      this.calcEl
        .find("[name=length-m]")
        .val(Math.round(runningMeters * 100) / 100);

      // area
      const area = (board.area * plankCount) / 100;
      this.calcEl.find("[name=area]").val(Math.round(area * 100) / 100);

      // volume
      const volume = (board.area * board.height * plankCount) / 100000;
      this.calcEl.find("[name=volume]").val(Math.round(volume * 1000) / 1000);

      this.calcTotalPrice();
    });

    // On meter change.
    this.calcEl.find("[name=length-m]").on("input", (e) => {
      const board = ProductCalculator.board;

      const lengthM = parseFloat(e.target.value);

      // Boards needed
      const plankCount = Math.ceil((lengthM * 1000) / board.length);
      this.calcEl.find("[name=plank-count]").val(plankCount);

      // area
      const area = (board.area * plankCount) / 100;
      this.calcEl.find("[name=area]").val(Math.round(area * 100) / 100);

      // volume
      const volume = (board.area * board.height * plankCount) / 100000;
      this.calcEl.find("[name=volume]").val(Math.round(volume * 1000) / 1000);

      this.calcTotalPrice();
    });

    // On area change
    this.calcEl.find("[name=area]").on("input", (e) => {
      const board = ProductCalculator.board;

      const area = parseFloat(e.target.value) * 100;

      // Boards needed
      const plankCount = Math.ceil(area / board.area);
      this.calcEl.find("[name=plank-count]").val(plankCount);

      // running meters
      const runningMeters = (plankCount * board.length) / 1000;
      this.calcEl
        .find("[name=length-m]")
        .val(Math.round(runningMeters * 100) / 100);

      // volume
      const volume = (board.area * board.height * plankCount) / 100000;
      this.calcEl.find("[name=volume]").val(Math.round(volume * 1000) / 1000);

      this.calcTotalPrice();
    });

    // On volume change
    this.calcEl.find("[name=volume]").on("input", (e) => {
      const board = ProductCalculator.board;

      const volume = parseFloat(e.target.value) * 100000;

      // Boards needed
      const plankCount = volume / (board.area * board.height);
      this.calcEl.find("[name=plank-count]").val(Math.ceil(plankCount));

      // running meters
      const runningMeters = (plankCount * board.length) / 1000;
      this.calcEl
        .find("[name=length-m]")
        .val(Math.round(runningMeters * 100) / 100);

      // area
      const area = (board.area * plankCount) / 100;
      this.calcEl.find("[name=area]").val(Math.round(area * 100) / 100);

      this.calcTotalPrice();
    });
  },

  /**
   * Runs the calculation
   */
  createCalc(value = null) {
    if (!value) {
      if ($(".variations_form").length) {
        value = this.selectLengthEl.val();
      } else {
        value = this.calcEl.find("[name=length]").val();
      }
    }

    if ($(".variations_form").length) {
      const variations = $(".variations_form").data("product_variations");
      const selectedVariation = variations.find((v) => v.length == value);

      if (selectedVariation.board_gap) {
        this.gapEl.parent().removeClass("hidden");

        this.calcEl.find("[name=gap]").val(selectedVariation.board_gap);
        this.gapEl.text(selectedVariation.board_gap);
      } else {
        this.gapEl.parent().addClass("hidden");
      }
    }

    if ($(".variations_form").length) {
      this.calcEl.find("[name=length]").val(value);
      this.lengthEl.text(value);
    }

    // Set board values
    const board = {
      width: parseFloat(this.calcEl.find("[name=width]").val()),
      height: parseFloat(this.calcEl.find("[name=height]").val()),
      length: parseFloat(this.calcEl.find("[name=length]").val()),
      gap: parseFloat(this.calcEl.find("[name=gap]").val()),
    };

    board.area = ((board.width + board.gap) * board.length) / 10000;

    ProductCalculator.board = board;

    // Set values
    this.calcEl.find("[name=plank-count]").trigger("input");

    ProductCalculator.calcValues();
  },

  /**
   * Calculate total price
   */
  calcTotalPrice() {
    const price = parseFloat(this.calcEl.find("[name=price]").val());
    const boardsNeeded = parseFloat(
      this.calcEl.find("[name=plank-count]").val()
    );

    let boardsInPack = parseFloat(
      this.calcEl.find('[name="boards-in-pack"]').val()
    );
    boardsInPack = boardsInPack ? boardsInPack : 1;

    // Total price
    const unit = Math.ceil(boardsNeeded / boardsInPack);
    const totalPrice = Math.round(unit * price * 100) / 100;

    this.calcEl.find(".calc-qty").text(unit);
    this.calcEl.find(".calc-price").text(price);
    this.calcEl.find(".calc-total-price").text(totalPrice);
  },

  /**
   * Calculate values
   */
  calcValues() {
    const board = ProductCalculator.board;
    const price = parseFloat(this.calcEl.find("[name=price]").val());

    let boardsInPack = parseFloat(
      this.calcEl.find('[name="boards-in-pack"]').val()
    );
    boardsInPack = boardsInPack ? boardsInPack : 1;

    // Price per piece
    const pricePerPiece = Math.round((price / boardsInPack) * 100) / 100;
    this.calcEl.find(".board-price").text(pricePerPiece);

    // Price in meter
    const priceInMeter = (price * 1000) / (board.length * boardsInPack);
    this.calcEl.find(".meter-price").text(Math.round(priceInMeter * 100) / 100);

    // price area
    const areaSqm = (board.length * board.width * boardsInPack) / 1000;
    const priceArea = (price * 1000) / areaSqm;
    this.calcEl.find(".area-price").text(Math.round(priceArea * 100) / 100);

    // price volume
    // const priceVolume = price / ((areaSqm * board.height) / 1000000);
    // this.calcEl.find(".volume-price").text(Math.round(priceVolume * 100) / 100);
  },
};

export default ProductCalculator;
